import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Save, ArrowLeft } from "lucide-react";

import useFetch from "../../hooks/useFetch";
import useUpdate from "../../hooks/useUpdate";
import useForm from "../../hooks/useForm";
import { validateProduct } from "../../helpers/productValidation";

function EditProduct() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { update, loading } = useUpdate("/products");
  const { data: product } = useFetch(`/products/${id}`);
  const { data: categories = [] } = useFetch("/categories");

  const { formData, errors, handleChange, handleSubmit, setFormData } = useForm(
    {
      initialValues: {
        name: "",
        description: "",
        useful_life: "",
        risk: "",
        minimum_stock: "",
        cum: "",
        category_id: "",
      },
      validate: validateProduct,
      loading,
      onSubmit: async (data) => {
        await update(id, data);
        toast.success("Producto actualizado exitosamente");
        navigate("/products");
      },
    },
  );

  const handleCategoryChange = (event) => {
    handleChange(event);
    if (event.target.value !== "11") {
      setFormData((previous) => ({ ...previous, cum: "" }));
    }
  };

  const showCum = String(formData.category_id) === "11";

  // 🔹 Cargar datos del producto cuando llega del backend
  useEffect(() => {
    if (product) {
      setFormData({
        name: product.name || "",
        description: product.description || "",
        useful_life: product.useful_life || "",
        risk: product.risk || "",
        minimum_stock: product.minimum_stock ?? "",
        cum: product.cum || "",
        category_id: product.category_id || "",
      });
    }
  }, [product, setFormData]);

  return (
    <div className="bg-white p-6 rounded-xl shadow-md max-w-xl mx-auto">
      <button
        onClick={() => navigate("/products")}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
      >
        <ArrowLeft size={20} />
        Volver a productos
      </button>

      <h2 className="text-3xl font-semibold text-gray-800 mb-6">
        Editar Producto
      </h2>

      {errors.general && (
        <p className="text-red-600 text-sm mb-3">{errors.general}</p>
      )}

      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Categoría */}
        <div>
          <label className="block text-sm font-medium mb-1">Categoría</label>
          <select
            name="category_id"
            value={formData.category_id}
            onChange={handleCategoryChange}
            className={`w-full border px-4 py-2 rounded-lg ${
              errors.category_id ? "border-red-500" : "border-gray-300"
            }`}
          >
            <option value="">Seleccionar categoría</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
          {errors.category_id && (
            <p className="text-red-600 text-sm">{errors.category_id}</p>
          )}
        </div>

        {/* Nombre */}
        <div>
          <label className="block text-sm font-medium mb-1">Nombre</label>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={`w-full border px-4 py-2 rounded-lg ${
              errors.name ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.name && <p className="text-red-600 text-sm">{errors.name}</p>}
        </div>

        {/* Descripción */}
        <div>
          <label className="block text-sm font-medium mb-1">Descripción</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="w-full border px-4 py-2 rounded-lg h-28 resize-none"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Stock mínimo</label>
          <input
            type="number"
            min="0"
            step="1"
            name="minimum_stock"
            value={formData.minimum_stock}
            onChange={handleChange}
            className="w-full border border-gray-300 px-4 py-2 rounded-lg"
          />
        </div>
{/* Vida útil y riesgo */}
<div className={`grid gap-4 ${showCum ? "grid-cols-3" : "grid-cols-2"}`}>
  <div>
    <label className="block text-sm font-medium mb-1">Vida útil</label>
    <input
      name="useful_life"
      value={formData.useful_life}
      onChange={handleChange}
      className={`w-full border px-4 py-2 rounded-lg ${
        errors.useful_life ? "border-red-500" : "border-gray-300"
      }`}
    />
    {errors.useful_life && (
      <p className="text-red-600 text-sm">{errors.useful_life}</p>
    )}
  </div>

  <div>
    <label className="block text-sm font-medium mb-1">Riesgo</label>
    <input
      name="risk"
      value={formData.risk}
      onChange={handleChange}
      className={`w-full border px-4 py-2 rounded-lg ${
        errors.risk ? "border-red-500" : "border-gray-300"
      }`}
    />
    {errors.risk && (
      <p className="text-red-600 text-sm">{errors.risk}</p>
    )}
  </div>

  {showCum && (
    <div>
      <label className="block text-sm font-medium mb-1">CUM</label>
      <input
        type="text"
        name="cum"
        value={formData.cum}
        onChange={handleChange}
        className="w-full border border-gray-300 px-4 py-2 rounded-lg"
      />
    </div>
  )}
</div>
        {/* Botón */}
        <div className="flex">
          <button
            type="submit"
            disabled={loading}
            className={`flex items-center gap-2 px-5 py-2 rounded-lg shadow ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-yellow-500 hover:bg-yellow-600 text-white"
            }`}
          >
            <Save size={18} />
            Guardar Cambios
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditProduct;
